<template>
  <div class="section">
    <div class="transaction__filter--container bg-white py-2">
      <div class="d-flex align-items-center search__export w-100">
        <div class="d-flex pl-2">
          <b-img
            class="filter-image"
            :class="filter.sort_type == 'asc' ? 'rotate-180' : ''"
            :src="require('@/assets/images/icons/Icon-order-list-down.svg')"
            alt="Icon-order-list-down"
            role="button"
            @click="filter.sort_type == 'asc' ? filter.sort_type = 'desc' : filter.sort_type = 'asc'"
          />
        </div>
        <div class="search__input w-100 px-2">
          <b-input-group>
            <b-form-input
              v-model="filter.search"
              placeholder="Cari No.Invoice"
            />
            <b-input-group-append is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
    </div>

    <div
      v-if="isLoading"
      class="d-flex justify-content-center mb-1 mt-5"
    >
      <b-spinner label="Loading..." />
    </div>
    <vue-good-table
      v-else
      style="z-index: 0;"
      max-height="80vh"
      :columns="columns"
      :rows="result"
      :fixed-header="false"
      :sort-options="{
        enabled: false
      }"
      :pagination-options="{
        enabled: false,
      }"
    >
      <template
        slot="table-column"
        slot-scope="props"
      >
        <span v-if="props.column.field == 'action'" />
      </template>
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Column: Invoice -->
        <span v-if="props.column.field === 'transaction.invoice_number' && typeRetur == 'Retur Penjualan'">
          <b-link @click="props.row.transaction && typeRetur == 'Retur Penjualan' ? getDetailInvoice(props.row.transaction.uuid) : ''">
            <span class="text-danger">{{ typeRetur == 'Retur Penjualan' ? props.row.transaction && props.row.transaction.invoice_number || '-' : props.row.transaction && props.row.transaction.po_so_id || '-' }}</span>
          </b-link>
        </span>

        <!-- Column: Retur Number -->
        <span v-else-if="props.column.field === 'retur_number'">
          <b-link @click="detailItem(props.row)">
            <span class="text-danger">
              {{ props.row.retur_number || '-' }}
            </span>
          </b-link>
        </span>

        <!-- Column: Name -->
        <span v-else-if="props.column.field === 'transaction.customer_name'">
          {{ props.row.transaction && props.row.transaction.customer_name || '-' }}
        </span>

        <!-- Column: Invoice Value -->
        <span v-else-if="props.column.field === 'invoice_value'">
          {{ props.row.invoice_value || 0 | formatAmount }}
        </span>

        <!-- Column: Invoice Value -->
        <span v-else-if="props.column.field === 'return_value'">
          {{ props.row.return_value || 0 | formatAmount }}
        </span>

        <span v-else-if="props.column.field === 'discount'">
          {{ props.row.discount || 0 | formatAmount }}
        </span>

        <span v-else-if="props.column.field === 'operator'">
          {{ props.row.operator && props.row.operator.name || '-'}}
        </span>

        <span v-else-if="props.column.field === 'total_value'">
          <span v-if="summaryTotalValue(props.row) > 0">{{ summaryTotalValue(props.row) | formatAmount }}</span>
        </span>
        
        <span v-else-if="props.column.field === 'payment_method'">
          <span class="text-capitalize" v-if="!props.row.is_split_payment_method">
            {{ paymentMethod(props.row.payment_method) }}
          </span>
          <span class="text-capitalize" v-else>
            {{ props.row.payment_method_details.map(e => paymentMethod(e.payment_method)).join(', ') }}
          </span>
        </span>
        
        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge
          class=""
          :variant="props.row.status == 'pending' ? 'warning' : (props.row.status == 'rejected' ? 'danger' : 'success') "
          >
          {{ props.row.status }}
        </b-badge>
      </span>

      <span v-else-if="props.column.field === 'action_time'">
        <span
          v-if="['success', 'rejected'].includes(props.row.status) && props.row.action_time"
        >
          {{ props.row.action_time | formatDateRetur }}
        </span>
        <span v-else>-</span>
      </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span v-if="props.row.status !== 'success' && props.row.status !== 'rejected'">
            <b-dropdown
              id="dropdown-dropleft"
              class="d-flex"
              right
            >
              <template
                #button-content
                class="btn-white text-center"
              >
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle"
                />
              </template>
              <!-- <b-dropdown-item @click="editItem(props.row.uuid, 'edit')">
                <span>
                  Edit Retur Penjualan
                </span>
              </b-dropdown-item> -->
              <b-dropdown-item
                v-if="checkPermission('approve retur')"
                @click="editItem(props.row.uuid, 'approve')"
              >
                <span>
                  Approve
                </span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="checkPermission('reject retur')"
                @click="editItem(props.row.uuid, 'reject')"
              >
                <span>
                  Reject
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
          <span v-if="props.row.status === 'success'">
             <b-dropdown
              id="dropdown-dropleft"
              class="d-flex"
              right
            >
              <template
                #button-content
                class="btn-white text-center"
              >
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle"
                />
              </template>
              <b-dropdown-item
                     @click="$router.push({
                     name: 'retur.detail.index',
                    params: { id: props.row.uuid },
                    query : {...$route.query}
                    });"
              >
                <span>
                  Cetak  
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <div
      v-if="rows && !isLoading"
      class="d-flex justify-content-between align-items-center flex-wrap bg-white border"
      style="padding: 0.8rem;"
    >
      <div class="d-flex align-items-center">
        <b-form-select
          v-model="filter.per_page"
          :options="['10','15','20']"
          class="mx-1"
        />
        <span class="text-nowrap">
          Tampilkan {{ (rows.total > 0) ? (filter.per_page * (rows.current_page - 1)) + 1 : 0 }} ke
          {{ (rows.total > 0) ? Math.min(filter.per_page * rows.current_page, rows.total) : 0 }} dari {{ rows.total }} transaksi.
        </span>
      </div>
      <div>
        <b-row class="mx-0 align-items-center">
          <b-col>
            <pagination
              class="mb-0"
              :data="rows"
              :limit="4"
              align="right"
              @pagination-change-page="getData"
            />
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalRetur
      :is_edit="isEdit"
      :retur-type="type"
      :get-data="getData"
      :is-approve="isApprove"
      :results="returData"
    />
    <DetailHistoryTransaction :historyDetail="historyDetail" :delivery-numbers="deliveryNumbers" :isLoadingDetailInvoice="isLoadingDetailInvoice" />
    
    <b-modal
      size="lg"
      id="modal-detail-retur-penjualan"
      centered
      hide-footer
      title="Detail Retur Penjualan"
      @show="handleOpenModalRetur"
    >
      <b-overlay
        :show="isLoadingRetur"
        rounded="sm"
        no-fade
      >
        <b-container id="contentPrint" class="h-100 bg-wave">
          <div class="px-lg-1 px-1 pb-3">
              <!-- Logo -->
              <b-img 
                  v-if="hasValidPhoto" 
                  :src="photoRetur" 
                  alt="logo" 
                  class="custom-img"
                  style="margin-left: 145px; width: 100px; height: auto;" 
              />

              <!-- Detail -->
              <b-row class="mt-2">
                  <b-col lg="12">
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0" v-if="detailRetur.type === 'order'">
                          No. Invoice: {{ detailRetur.transaction.invoice_number || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0">
                          No. Retur: {{ detailRetur.retur_number || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0">
                          Tanggal: {{ detailRetur.date || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0" v-if="detailRetur.type === 'order'">
                          Sales: {{ detailRetur.transaction.seller_name || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0" v-if="detailRetur.type === 'order'">
                          Pelanggan: {{ detailRetur.transaction.customer_name || '-' }}
                      </h6>
                      <h6 class="size10 fw-bold-500 text-black mb-1 mb0"
                          v-else-if="detailRetur.type === 'incoming_stock'">
                          Pemasok: {{ detailRetur.transaction.supplier_name || '-' }}
                      </h6>
                  </b-col>
                  <b-col lg="12">
                      <hr class="mb-25" style="border-top: 1px solid #000;">
                  </b-col>
              </b-row>

              <!-- List Produk -->
              <b-row>
                  <b-col lg="12">
                      <div v-for="(item, index) in detailRetur.items" :key="index" class="mb-25">
                          <div class="d-flex" style="height: 2rem">
                              <h6 class="size10 fw-bold-700 text-black px-0" v-if="detailRetur.type === 'order'">
                                  {{ item.item.name }}
                              </h6>
                              <h6 class="size10 fw-bold-700 text-black px-0" v-else-if="detailRetur.type === 'incoming_stock'">
                                  {{ item.item.product.name }}
                              </h6>
                          </div>
                          <div class="d-flex" style="height: 2rem">
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0"
                                  v-if="detailRetur.type === 'order'">
                                  {{ item.return_qty.toString().replace('.', ',') }} {{
                                      item.item.unit }}
                              </h6>
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0" v-else>
                                  {{ item.return_qty.toString().replace('.', ',') }} {{
                                      item.item.product.uom.name }}
                              </h6>
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0">
                                  {{ item.item.price | formatInvoice }}
                              </h6>
                              <h6 class="size10 fw-bold-500 text-black col-3 px-0 text-right">
                                  {{ item.return_value | formatInvoice }}
                              </h6>
                          </div>
                      </div>
                  </b-col>
                  <b-col lg="12">
                      <hr class="mt-25" style="border-top: 1px solid #000;">
                  </b-col>
              </b-row>
              <!-- <hr class="my-0" style="border-top: 1px solid #000;"> -->

              <!-- Total Retur -->
              <b-row>
                  <b-col lg="12">
                      <div class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                          <h6 class="text-black size12 mb-0 fw-bold-700">
                              Total Diskon Retur
                          </h6>
                          <h6 class="text-black size10 mb-0 fw-bold-700">
                              {{ detailRetur.discount | formatAmount }}
                          </h6>
                      </div>
                      <div v-if="!detailRetur.is_split_payment_method">
                          <div class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                              <h6 class="text-black size12 mb-0 fw-bold-700">
                                  {{ paymentMethod(detailRetur.payment_method) }}
                              </h6>
                              <h6 class="text-black size10 mb-0 fw-bold-700">
                                  {{ detailRetur.return_value | formatAmount }}
                              </h6>
                          </div>
                      </div>
                      <div v-if="detailRetur.is_split_payment_method">
                          <div v-for="(payment, index) in detailRetur.payment_method_details" :key="index" class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                              <h6 class="text-black size12 mb-0 fw-bold-700">
                                  {{ paymentMethod(payment.payment_method) }}
                              </h6>
                              <h6 class="text-black size10 mb-0 fw-bold-700">
                                  {{ payment.amount | formatAmount }}
                              </h6>
                          </div>
                      </div>
                      <div class="d-flex justify-content-between" style="margin-bottom: 0.5rem;">
                          <h6 class="text-black size12 mb-0 fw-bold-700">
                              Total Retur
                          </h6>
                          <h6 class="text-black size10 mb-0 fw-bold-700">
                              {{ (detailRetur.return_value - (detailRetur.discount || 0)) | formatAmount }}
                          </h6>
                      </div>
                  </b-col>
              </b-row>
          </div>
        </b-container>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink, BRow, BCol, BDropdown, BDropdownItem, VBToggle, BFormInput, BInputGroup, BInputGroupAppend, BImg, BBadge, BSpinner, BFormSelect, BContainer, BOverlay
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import ModalRetur from '@/components/Retur/Modal/ModalRetur.vue'
import DetailHistoryTransaction from "@/components/Transaction/Modal/DetailHistoryTransaction.vue";
import Retur from '@/components/Retur.vue'
import { VueGoodTable } from 'vue-good-table'
import { props } from 'vue-prism-component'

export default {
  components: {
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    BSpinner,
    ModalRetur,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BBadge,
    BRow,
    BCol,
    BFormSelect,
    BLink,
    DetailHistoryTransaction,
    Retur,
    BContainer,
    BOverlay
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    results: {
      type: Object,
    },
    getData: {
      type: Function,
    },
    isLoading: {
      type: Boolean,
    },
    typeRetur: {
      type: String,
      default: 'Retur Penjualan',
    },
  },
  setup() {
    return {
      checkPermission, successNotification, errorNotification,
    }
  },
  computed: {
    hasValidPhoto() {
        const photoUrl = this.detailRetur?.transaction?.branch?.photo_url;
        if (!photoUrl) return false;
        return ['png', 'jpg'].some(ext => photoUrl.includes(ext));
    },
    photoRetur() {
      return this.detailRetur?.transaction?.branch?.photo_url || null;
    }
  },
  data() {
    return {
      isApprove: false,
      filter: {
        per_page: 10,
        sort_type: 'desc',
        search: '',
        // type: '',
      },
      columns: [
        {
          label: 'Tanggal Pengajuan',
          field: 'date',
        },
        {
          label: 'Tanggal Persetujuan',
          field: 'action_time',
        },
        {
          label: 'No. Invoice',
          field: this.typeRetur === 'Retur Penjualan' ? 'transaction.invoice_number' : 'transaction.po_so_id',
        },
        {
          label: 'No. Retur',
          field: 'retur_number',
        },
        {
          label: 'Nama Customer',
          field: 'transaction.customer_name',
        },
        {
          label: 'Nilai Invoice (Rp)',
          field: 'invoice_value',
        },
        {
          label: 'Nilai Retur (Rp)',
          field: 'return_value',
        },
        {
          label: 'Diskon',
          field: 'discount',
        },
        {
          label: 'Total Pengembalian',
          field: 'total_value',
        },
        {
          label: 'Metode Retur',
          field: 'payment_method',
        },
        {
          label: 'Diajukan Oleh',
          field: 'operator',
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: {},
      result: [],
      isEdit: false,
      type: 'order',
      returData: null,
      historyDetail: {},
      deliveryNumbers: [],
      isLoadingDetailInvoice: false,
      detailRetur: {},
      merchant: {},
      returnUuid: null,
      isLoadingRetur: false,
    }
  },
  watch: {
    typeRetur(value) {
      if (value === 'Retur Penjualan') {
        // this.filter.type = 'order'
        this.type = 'order'
      }
      if (value === 'Retur Pembelian') {
        // this.filter.type = 'incoming_stock'
        this.type = 'incoming_stock'
      }
    },
    results: {
      handler(value) {
        this.rows = value
        this.result = value.data
      },
      deep: true,
    },
    filter: {
      handler(value) {
        this.$emit('filter', value)
         // If `search` is updated, remove unwanted query parameters
        if (value.search) {
          this.$router.replace({
            query: {
              ...this.$route.query,
              page: undefined,
            },
          });
        }
      },
      deep: true,
    },
  },
  created() {
  },
  mounted() {
    this.rows = this.results
    this.result = this.results.data
  },
  methods: {
    handleOpenModalRetur() {
      this.getDetail()
      this.getMerchant()
    },
    getDetail() {
      this.isLoadingRetur = true
      this.$store.dispatch(`returs/getData`, {
          uuid: this.returnUuid,
      })
        .then(result => {
            this.detailRetur = result.data.data;
            this.isLoadingRetur = false
        }).catch(err => {
          this.isLoadingRetur = false
            console.log(err);
        });
    },
    getMerchant() {
        this.$store.dispatch('profile/getMerchant')
            .then(result => {
                this.merchant = result.data.data;
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.log(err)
            })
    },
    async getDetailInvoice(id) {
      this.isLoadingDetailInvoice = true
      this.$bvModal.show("modal-history-detail");
      this.$store
        .dispatch("order/getData", {
          uuid: `${id}/detail`,
          params: "",
        })
        .then((result) => {
          this.historyDetail = result.data.data;
          result.data.data.items.forEach((element) => {
            if (element.delivery_numbers.length) {
              this.deliveryNumbers.push(
                ...element.delivery_numbers.map((e) => e.delivery_number_note)
              );
            }
          });
          this.isLoadingDetailInvoice = false
        })
        .catch((err) => {
          this.isLoadingDetailInvoice = false
          // eslint-disable-next-line no-console
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
          }
        })
    },
    paymentMethod(method) {
      const paymentMethod = {
        cash: 'Tunai',
        tunai: 'Tunai',
        transfer: 'Transfer',
        wallet: 'Deposit',
        piutang: 'Piutang', 
        point: 'Customer Point',
        card: "Kredit atau Debit",
        giro: "Giro",
      }
      return paymentMethod[method] || method || '-';
    },
    summaryTotalValue(item) {
      return (item.return_value - item.discount)
    },
    editItem(id, type) {
      this.$store.dispatch('returs/getData', {
        uuid: id,
        params: '',
      }).then(result => {
        this.isEdit = true
        this.isApprove = !!(type === 'approve' || type === 'reject')
        this.returData = result.data.data
        this.$store.commit('order/setDataRetur', result.data.data)
        this.$bvModal.show('modal-retur')
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    detailItem(row) {
      this.detailRetur = {}
      this.returnUuid = row.uuid
      this.$bvModal.show('modal-detail-retur-penjualan')
      // const uuid = row.uuid;

      // this.$router.push({
      //   name: 'retur.detail.index',
      //   params: { id: uuid },
      // });
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@/assets/scss/variables/_variables.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
.vgt-responsive {
  height: calc(100vh - 322px) !important;
  background-color: #fff;
}
.retur-penjualan {
  position: relative;

  .transaction__filter--container {
    display: flex;
    justify-content: space-between;

    .search__export {
      width: 100%;
      .search__input {
        margin-right: 8px;
        .input-group {
          box-shadow: none !important;
          height: 48px;
          width: 100% !important;

          input {
            height: 48px;
            border: none;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            background: #F1F2F5;
          }

          .input-group-append {
            .input-group-text {
              background: #F1F2F5;
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
              border: none;
            }
          }
        }
      }
    }
  }

  .vgt-responsive {
    height: 71vh;
    background-color: #fff;
  }

  .vgt-table.bordered {
    border-left: none;
    thead {
      th:last-child {
        text-align: center;
      }
    }
    td {
      border: none;
      border-bottom: 1px solid #ebe9f1;
      vertical-align: middle;
      color: $dark;
      font-weight: 600;
    }
    th {
      border: none;
      border-bottom: 1px solid #ebe9f1;
      color: #7A7F94;
      font-weight: 600;
    }

  }

  .page-item {
    .page-link {
      font-weight: 600;
      color: $secondary-2 !important;
      background-color: transparent;
    }
    &.active {
      .page-link {
        border-radius: 0;
        background-color: $light--1;
        font-weight: 600;
        color: $secondary-2 !important;
      }
    }
  }

  .page-item.prev-item ~ .page-item:nth-child(2) .page-link {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .page-item.prev-item ~ .page-item:nth-last-child(2) .page-link {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .page-item.next-item .page-link:active,
  .page-item.next-item .page-link:hover {
    background-color: transparent !important;
  }

  .pagination__container {
    width: 100%;
    height: 80px;
    position: fixed;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid #E4E5EC;

    .dropdown {

      button {
        font-size: 14px;
        color: $dark;
        font-weight: 600;

        &:hover {
          background-color: transparent;
        }
      }
    }

    small {
      color: $secondary-2;
      font-size: 14px;
      font-weight: 400;
    }
  }

  #dropdown-dropleft {
    .dropdown-toggle {
      border-color: transparent !important;
      background-color: transparent !important;
      color: $dark !important;

      &:hover {
        border-color: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
      }
    }
  }

  .vs__open-indicator {
    fill: rgba(60, 60, 60, 0.5);
  }
}
</style>
